module.exports = __webpack_public_path__ + "static/fonts/Oswald-Demi-BoldItalic.1681f3f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Oswald-Demi-BoldItalic.ttf
// module id = UMSM
// module chunks = 1